import {WorkbenchContextService} from './workbench-context.service';
import {WindowRef} from './window';
import {Injectable} from '@angular/core';
import {WorkbenchPopoutConfig} from '../types';
import {WorkbenchOpenService} from '@webmate-web-core/shared/workbench-ipc';

@Injectable()
export class WorkbenchPopoutService {
    constructor(private workbenchContextService: WorkbenchContextService,
                private readonly windowRef: WindowRef,
                private readonly workbenchOpenService: WorkbenchOpenService) {}

    openDeviceConsolePopout(config: WorkbenchPopoutConfig): Window | null {
        const context = this.workbenchContextService.getCurrentWorkbenchContext();
        if (!context) {
            console.error('No workbench context available to open popout');
            return null;
        }

        if (context.isChildWorkbench || context.parentWorkBench) {
            console.warn('Cannot open popout from a child workbench');
            return null;
        }

        // Build the workbench URL through the canonical builder so all workbench URLs stay consistent.
        const url = this.workbenchOpenService.createWorkbenchUrl({
            projectId: config.projectId,
            deviceId: config.deviceId,
            childWorkbench: true,
            popoutConsoleId: config.consoleIdentifier
        });
        const childWindow = this.windowRef.open(url);

        if (!childWindow) {
            console.error('Failed to open popout window');
        }

        return childWindow;
    }
}
